export const GLOBAL_FAQS = [
  {
    q: "How long do water testing results take?",
    a: "Most reports are usually returned within 1–3 days, depending on the test package, sample timing and lab workload. Bacterial tests (E. coli, coliforms) start the day your sample arrives at the lab.",
  },
  {
    q: "What's the difference between the AWARE 4-Point and the AWARE Tank 360?",
    a: "The AWARE 4-Point ($129) screens for E. coli (Positive/Negative) and Coliforms (Positive/Negative) plus pH and Conductivity — answering the question 'is my water safe to drink?'. The AWARE Tank 360 ($209) adds TDS, turbidity, alkalinity, hardness, cations, anions and metals — giving you a broader picture of your rainwater tank's water quality and overall system health.",
  },
  {
    q: "Do I have to bring the sample in person?",
    a: "No — you have two options. Drop-off: bring your labelled sample to 1/37 Gateway Drive, Noosaville. Or mail-out: when you book online we post you a sampling kit — sterile bottles, step-by-step collection instructions and a pre-paid express-post return tube. You collect your water sample, drop the tube in any Australia Post box, and we email your report.",
  },
  {
    q: "What does the 'plain-English summary' mean?",
    a: "Alongside your standard Certificate of Analysis, we provide a one-page summary that explains in plain English what was found, what it means, and whether any action is required. No technical jargon.",
  },
  {
    q: "What if my results show a problem?",
    a: "Your plain-English Summary Report includes Recommended Actions where relevant. When treatment or corrective work is suggested, you can request a free Pristine Water Systems proposal/assessment directly from your report — no extra fee.",
  },
  {
    q: "Do you test town water?",
    a: "Aware Water Testing currently focuses on rainwater tank and bore water testing. We do not currently offer town water / mains water testing through our online booking system.",
  },
];

export const suburbFAQ = (suburb) => [
  {
    q: `Do you service ${suburb} for water testing?`,
    a: `Yes — we service ${suburb} from our Noosaville laboratory. You can drop samples in person if you're close by, or post them to our lab from anywhere in Australia. Most ${suburb} customers post their sample using Australia Post Express.`,
  },
  {
    q: `What's the most common water issue in ${suburb}?`,
    a: `${suburb} properties typically use rainwater tanks, bore water, or both. Common issues we identify include bacterial contamination from bird droppings, low pH from soft rainwater, and iron/manganese in bores. We focus on private water supplies — town/mains water testing is not currently offered through our online booking system.`,
  },
  {
    q: `How fast can I get results in ${suburb}?`,
    a: "Once your sample reaches our Noosaville lab, reports are usually returned within 1–3 days, depending on the test package, sample timing and lab workload. Bacterial samples are time-sensitive, so prompt drop-off helps avoid delays.",
  },
  {
    q: `How much does water testing cost in ${suburb}?`,
    a: "One flat, all-inclusive price nationwide. AWARE 4-Point $129, AWARE Tank 360 $209, AWARE Bore 360 $229 — same national prices, whether you're in Noosaville or elsewhere in Australia.",
  },
  {
    q: "Can you explain my results in plain English?",
    a: "Yes — every report includes a plain-English summary explaining what was found, what it means, and whether action is required. If treatment is suggested, you can request a free Pristine Water Systems proposal/assessment from the report.",
  },
];
